import React, { Component } from 'react'
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  Container,
  Badge,
  Card ,
  ButtonGroup,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import { APIKEY } from "../../Config/Config";
export default class Dashboard extends Component {
  constructor(){
     super()
    this.state={
      MarketPlace:"",
      Blog:"",
      Event:"",
      Resources:"",
      TechTalks:"",
      News:"",
      Jobs:"",
    }
   
  }
  componentDidMount() {
    this.MarketPlace();
    this.Blog();
    this.Event();
    this.Resources();
    this.TechTalks();
    this.News();
    this.Jobs();
   
  }
  MarketPlace (){
    axios.get(`${APIKEY}/MarketPlace/admin`).then((res) => {
      this.setState({
        MarketPlace: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  Blog (){
    axios.get(`${APIKEY}/Blog/admin`).then((res) => {
      this.setState({
        Blog: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  Event (){
    axios.get(`${APIKEY}/Events/admin`).then((res) => {
      this.setState({
        Event: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  Resources (){
    axios.get(`${APIKEY}/Resources/admin`).then((res) => {
      this.setState({
        Resources: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  TechTalks(){
    axios.get(`${APIKEY}/TechTalk/admin`).then((res) => {
      this.setState({
        TechTalks: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  News (){
    axios.get(`${APIKEY}/News`).then((res) => {
      this.setState({
        News: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  Jobs (){
    axios.get(`${APIKEY}/Jobs`).then((res) => {
      this.setState({
        Jobs: res.data.length,
       
      });
     
    }).catch((e)=>{
        console.log(e)
   });
  }
  render() {
    return (
     <React.Fragment>
      <Row>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.BarChart className="text-primary fa-3x fa" />
     
  <div className="ms-3">
    <p className="mb-2"> MarketPlace</p>
    <h6 className="mb-0">{this.state.MarketPlace}</h6>
  </div>
</div>


        </Col>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.PencilSquare className="text-primary fa-3x fa" />
  <div className="ms-3">
    <p className="mb-2"> Blog</p>
    <h6 className="mb-0">{this.state.Blog}</h6>
  </div>
</div>


        </Col>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.CalendarDay className="text-primary fa-3x fa" />
  <div className="ms-3">
    <p className="mb-2"> Event</p>
    <h6 className="mb-0">{this.state.Event}</h6>
  </div>
</div>


        </Col>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.PersonGear className="text-primary fa-3x fa" />
  <div className="ms-3">
    <p className="mb-2"> Resources</p>
    <h6 className="mb-0">{this.state.Resources}</h6>
  </div>
</div>


        </Col>
   
       
     
      </Row> <br></br>
      <Row>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.CardHeading className="text-primary fa-3x fa" />
  <div className="ms-3">
    <p className="mb-2"> Tech Talks</p>
    <h6 className="mb-0">{this.state.TechTalks}</h6>
  </div>
</div>


        </Col>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.Newspaper className="text-primary fa-3x fa" />
  <div className="ms-3">
    <p className="mb-2">News </p>
    <h6 className="mb-0">{this.state.News}</h6>
  </div>
</div>


        </Col>
      <Col md={3}>
     <div className="bg-light rounded d-flex align-items-center justify-content-between p-4">
     <Icon.Search className="text-primary fa-3x fa" />
  <div className="ms-3">
    <p className="mb-2">Jobs </p>
    <h6 className="mb-0">{this.state.Jobs}</h6>
  </div>
</div>


        </Col>
      </Row>
     
     
     </React.Fragment>
    )
  }
}
